export default __webpack_public_path__ + "static/media/PoweredBy_Light.fdc4aa25.svg";